export const addLeadingZero = (num: number) =>
	num < 10 ? `0${num}` : `${num}`;
